<template>
  <q-table
    flat
    bordered
    :data="reports"
    row-key="id"
    :columns="columns"
    :pagination="pagination"
    :visible-columns="visibleColumns"
  >
    <template v-slot:top-right>
      <q-btn
        outline
        color="grey-3"
        size="12px"
        text-color="grey-8"
        icon-right="archive"
        class="q-mr-sm q-py-xs"
        no-caps
        @click="exportClickReport()"
        unelevated
      >
        <q-tooltip> {{ $t('export_csv') }}</q-tooltip>
      </q-btn>
      <q-select
        v-model="visibleColumns"
        multiple
        outlined
        dense
        options-dense
        :display-value="$t('customize_columns')"
        emit-value
        map-options
        :options="columns"
        option-value="name"
        options-cover
        style="min-width: 150px"
      >
        <template v-slot:option="{ itemProps, itemEvents, opt, selected, toggleOption }">
          <q-item v-bind="itemProps" v-on="itemEvents">
            <q-item-section>
              <q-item-label v-html="opt.label"></q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-toggle :value="selected" @input="toggleOption(opt)" />
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </template>

    <template v-slot:body-cell-ctr="props">
      <q-td :props="props">
        {{ `${props.row.ctr.toFixed(2)}%` }}
      </q-td>
    </template>

    <template v-slot:bottom>
      <!-- <pagination-table-reports
                @change="getClickReport"
                :data="reqPagination"
                :pagination="pagination"
              /> -->
      <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
        Total:{{ reqPagination.total }}
        <q-space />
        <q-pagination
          unelevated
          v-model="currentPage"
          color="primary"
          :max="reqPagination.last_page"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </q-toolbar>
    </template>
  </q-table>
</template>

<script>
import ReportMixin from '../../../mixins/ReportMixin';
// import PaginationTableReports from "../PaginationTableReports";

export default {
  //   components: { PaginationTableReports },
  name: 'AdvertiserListClickReports',
  mixins: [ReportMixin],

  data() {
    return {
      visibleColumns: null,
      columns: [
        {
          name: 'indice',
          label: this.$t('index'),
          align: 'left',
          field: 'indice',
          sortable: true
        },
        {
          name: 'id_site',
          label: this.$t('channel_id'),
          align: 'left',
          field: 'id_site',
          sortable: true
        },
        {
          name: 'impressoes',
          label: this.$t('impressions'),
          align: 'left',
          field: 'impressoes',
          sortable: true
        },
        {
          name: 'total',
          label: this.$t('total_clicks'),
          align: 'left',
          field: 'total',
          sortable: true
        },
        {
          name: 'visitantes_unicos',
          label: this.$t('single_clicks'),
          align: 'left',
          field: 'visitantes_unicos',
          sortable: true
        },
        {
          name: 'ctr',
          label: 'CTR %',
          align: 'left',
          field: 'ctr',
          sortable: true
        },
        {
          name: 'cadastros_pendentes',
          label: this.$t('pending_leads'),
          align: 'left',
          field: 'cadastros_pendentes',
          sortable: true
        },
        {
          name: 'cadastros_aprovados',
          label: this.$t('approved_leads'),
          align: 'left',
          field: 'cadastros_aprovados',
          sortable: true
        },
        {
          name: 'lcr',
          label: 'LCR %',
          align: 'left',
          field: 'lcr',
          sortable: true
        },
        {
          name: 'vendas_pendentes',
          label: this.$t('pending_sales'),
          align: 'left',
          field: 'vendas_pendentes',
          sortable: true
        },
        {
          name: 'vendas_aprovadas',
          label: this.$t('approved_sales'),
          align: 'left',
          field: 'vendas_aprovadas',
          sortable: true
        },
        {
          name: 'scr',
          label: 'SCR %',
          align: 'left',
          field: 'scr',
          sortable: true
        },
        {
          name: 'valor_total_pendente',
          label: this.$t('transaction_amount_pending'),
          align: 'left',
          field: 'valor_total_pendente',
          sortable: true
        },
        {
          name: 'valor_total_aprovado',
          label: this.$t('transaction_amount_approved'),
          align: 'left',
          field: 'valor_total_aprovado',
          sortable: true
        }
      ],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: 10
      }
    };
  },
  methods: {
    async exportClickReport() {
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          'redirect?app=report&path=/api/old/report/advertiser_click_report_csv?' + this.filterReports
        );
        if (status === 200 || status === 201) {
          console.log(data);
          this.exportTableCsv(data, this.columns, 'click-reports');
          this.successNotify('Exportado com sucesso!');
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  },
  watch: {
    currentPage() {
      this.getClickReportAdvertiser(`%26page=${this.currentPage}`, `%26per_page=${this.pagination.rowsPerPage}`);
    },
    filterReports() {
      if (this.filterReports && this.filterReports.includes('filter=site'))
        this.visibleColumns = this.columns.map((column) => column.name);
      else this.visibleColumns = this.columns.filter((item) => item.name != 'id_site').map((column) => column.name);
    }
  },

  computed: {
    show() {
      return typeof this.reports === 'undefined' ? false : true;
    },

    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    }
  },

  created() {
    this.ActionSetFilterReports();
    this.ActionSetReports();
    this.visibleColumns = this.columns.filter((item) => item.name != 'id_affiliate').map((column) => column.name);
  }
};
</script>
